import React from 'react';
import ComboSelector, { TipoClave } from '../UI/campos/ComboSelector.js';

const opciones = [
  { codigo: '', descripcion: '' },
  { codigo: 'A', descripcion: 'Anulado' },
  { codigo: 'C', descripcion: 'Continuado' },
  { codigo: 'F', descripcion: 'Finalizado' },
];

const SelectResolucionResultado = (props) => {
  const codigoActual = props.codigoActual;
  const estilo = props.estilo;
  const dropUp = props.dropUp;

  const valorActual =
    opciones.find((opcion) => opcion.codigo === (codigoActual || ''))?.descripcion || '';

  const onItemElegido = (opcion) => {
    props.onResolucionElegida(opcion.codigo || null);
  };

  return (
    <ComboSelector
      estilo={estilo}
      lista={opciones}
      valorActual={valorActual}
      campoClave={TipoClave.CODIGO}
      campoDescripcion="descripcion"
      dropUp={dropUp}
      onItemElegido={onItemElegido}
    />
  );
};

export default SelectResolucionResultado;
